import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { ReactNode } from 'react';
import { Button } from '@sweep-io/sweep-design';
import { BackButton } from '../../dependencies/header/atoms/BackButton';
import { Panel } from '../../dependencies/header/atoms/Panel';
import { MiddlePanel } from '../../dependencies/header/atoms/MiddlePanel';
import { DependenciesSearchInput } from '../../dependencies/search/DependenciesSearchInput';
import { DependenciesSearchEntryIcon } from '../../dependencies/search/DependenciesSearchEntryIcon';

interface DocumentationCardHeaderLayoutProps {
  title: ReactNode;
  onGoBack?: () => void;
  shouldDisplayBackButton?: boolean;
  searchEnabled?: boolean;
  showAskAiButton?: boolean;
  onAskAiClick?: () => void;
  actions?: ReactNode;
}

export const DocumentationCardHeaderLayout = ({
  title,
  onGoBack,
  shouldDisplayBackButton = false,
  searchEnabled = false,
  showAskAiButton = false,
  onAskAiClick,
  actions,
}: DocumentationCardHeaderLayoutProps) => {
  return (
    <Panel sx={{ display: 'flex', flexDirection: 'column', width: '100%', gap: 0 }}>
      <Stack
        direction="row"
        justifyContent="space-between"
        gap={1}
        alignItems="center"
        width="100%"
      >
        {shouldDisplayBackButton && onGoBack && <BackButton onClick={onGoBack} />}

        <Box
          flex={1}
          display="flex"
          justifyContent="space-between"
          alignItems="flex-start"
          width="100%"
        >
          {title}

          <MiddlePanel>
            {searchEnabled && <DependenciesSearchEntryIcon />}

            {showAskAiButton && onAskAiClick && (
              <Stack sx={{ '& button': { whiteSpace: 'nowrap' } }}>
                <Button
                  variant="primary"
                  size="tiny"
                  startIconName="MagicWand"
                  onClick={onAskAiClick}
                  dataTestId="ask-ai-button"
                >
                  Ask AI
                </Button>
              </Stack>
            )}

            {actions}
          </MiddlePanel>
        </Box>
      </Stack>
      {searchEnabled && <DependenciesSearchInput />}
    </Panel>
  );
};
